import script from "./FormField.vue?vue&type=script&setup=true&lang=js"
export * from "./FormField.vue?vue&type=script&setup=true&lang=js"

import "./FormField.vue?vue&type=style&index=0&id=4957900b&lang=css"

const __exports__ = script;

export default __exports__